// 首页section3
var viewMoneTab3 = document.querySelector('.ccccl3')

var linkkk3 = viewMoneTab3.querySelectorAll('.collection-tabs__list-link3')
var buttonnn3 = viewMoneTab3.querySelectorAll('.tabs-loading-more-button3')



buttonnn3.forEach((b,i) => {
    if (i > 0) {
        b.classList.add('dis_none')
    }

})

linkkk3.forEach((l ,i) => {
    l.addEventListener('click', () => {
        // console.log('打印哒哒哒哒哒哒3' + i);
        buttonnn3.forEach((b,index) => {
            if (index === i) {
                b.classList.remove('dis_none');
            } else {
                b.classList.add('dis_none');
            }
        
        })


    })
})